const SITE_URL = "https://gadgetguymedia.com";

const upsert = (selector, create, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
  return el;
};

const meta = (attr, key, value) =>
  upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(attr, key);
    return m;
  }, "content", value);

// Applies title/meta/canonical/OG + optional JSON-LD; returns a cleanup fn.
export const applySeo = ({ path, title, description, schema, robots, ogImage }) => {
  const url = `${SITE_URL}${path}`;
  document.title = title;
  meta("name", "description", description);
  meta("property", "og:title", title);
  meta("property", "og:description", description);
  meta("property", "og:url", url);
  meta("name", "twitter:title", title);
  meta("name", "twitter:description", description);
  const prevOg = document.querySelector('meta[property="og:image"]')?.getAttribute("content");
  const prevTw = document.querySelector('meta[name="twitter:image"]')?.getAttribute("content");
  if (ogImage) {
    meta("property", "og:image", ogImage);
    meta("name", "twitter:image", ogImage);
  }
  upsert('link[rel="canonical"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "canonical");
    return l;
  }, "href", url);
  const prevRobots = document.querySelector('meta[name="robots"]')?.getAttribute("content");
  if (robots) meta("name", "robots", robots);
  let ld;
  if (schema) {
    ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.textContent = JSON.stringify(schema);
    document.head.appendChild(ld);
  }
  return () => {
    if (ld) ld.remove();
    if (robots && prevRobots) meta("name", "robots", prevRobots);
    if (ogImage && prevOg) meta("property", "og:image", prevOg);
    if (ogImage && prevTw) meta("name", "twitter:image", prevTw);
  };
};
